import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { withStyles } from "@material-ui/core/styles";
import Collapse from "@material-ui/core/Collapse";
import List from "@material-ui/core/List";
import { fade } from "@material-ui/core/styles/colorManipulator";
import ExpandMore from "@material-ui/icons/ExpandMore";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import clsx from "clsx";
import Tooltip from "@material-ui/core/Tooltip";
const menuItemsColor = "rgb(135,156,173)";
const styles = (theme) => {
  return {
    chevronIcon: {
      float: "right",
      marginLeft: "auto",
    },
    subMenus: {
      paddingLeft: 0,
    },
    popupSubMenus: {
      backgroundColor: "rgb(245,246,248)",
      color: menuItemsColor,
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px",
    },
    menuItem: {
      padding: "10px 16px",
      color: menuItemsColor,
      fontSize: 16,
      "&.menuActiveColor": {
        //backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        backgroundColor: "transparent",
        "& svg path[fill]": {
          fill: theme.palette.primary.main,
        },
        "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
          color: theme.palette.common.white,
        },
      },
    

      "&:focus": {
        //backgroundColor: theme.palette.primary.main,
        //backgroundColor:'red',
        color: theme.palette.primary.main,
        "& svg path[fill]": {
          fill: theme.palette.primary.main,
        },
        "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
          //color: theme.palette.common.white
          color: theme.palette.primary.main,
        },
      },
    },
    miniMenuItem: {
      color: menuItemsColor,
      padding: "10px 0",
      fontSize: 14,
      "&:focus": {
        //backgroundColor: theme.palette.primary.main,
        backgroundColor: "transparent",
        "& svg path[fill]": {
          fill: theme.palette.primary.main,
        },
        "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
          color: theme.palette.common.white,
        },
      },
      "& .menuActiveColor": {
        //backgroundColor: theme.palette.primary.main,
        backgroundColor: "transparent",
        "& svg path[fill]": {
          fill: theme.palette.primary.main,
        },
        "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
          color: theme.palette.common.white,
        },
      },
    },
    miniIcon: {
      margin: "0 auto",
      color: menuItemsColor,
      "&:hover": {
        backgroundColor: fade(theme.palette.common.white, 0.5),
      },
      minWidth: "24px",
    },
    activeColor:{
      "&.menuActiveColor":{
        backgroundColor: "transparent",
        "& svg path[fill]": {
          fill: theme.palette.primary.main,
        },
        "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
          color: theme.palette.common.white,
        },
        "& span":{
          color:theme.palette.primary.main
        }
      }
    }
  };
};

class NestedMenuItem extends React.Component {
  state = {
    anchorEl: null,
    open: false,
  };

   constructor(props) {
    super(props);
    this.myClass = "menuActiveColor";
    this.test = this.classAdding.bind(this);
    this.acitiveColorHandle  = () =>{
      let els = document.querySelectorAll(".menuList");
      let activeClss = sessionStorage.getItem("menuActiveColor")
        ? sessionStorage.getItem("menuActiveColor")
        : 0;
      els[activeClss].classList.add("menuActiveColor");
    }
  }
  // constructor(props) {
  //   super(props);
  //   this.myClass = "menuActiveColor";
  //   this.test = this.classAdding.bind(this);
  //   this.acitiveColorHandle  = () =>{
     
  //     let allMenus = document.querySelectorAll(".menuList");
  //     allMenus.forEach(function (eachMenu) {
  //       eachMenu.classList.remove("menuActiveColor");
  //     });
  //     let result = this.props.menus?.map(({ link }) =>{
  //       let lobName = "freightforwarding";
  //       let result = link && link.slice( link.indexOf(lobName)+lobName.length+1);
  //       let result3 = result.slice(0,result.indexOf('/'));
  //       return result3;
  //      })
   

  //       let url = window.location.href.indexOf("freightforwarding");
  //       let resultt = window.location.href.slice(url+18);
  //       let result2= resultt.indexOf('/');
  //       let result3 = resultt.slice(0,resultt.indexOf('/'));
        
        
  //       let menuArrays = result;
  //       let menuArraysondition = menuArrays
  //       if(menuArraysondition != null){
  //         menuArrays.forEach(function(arrayName,index){
  //           if(arrayName === result3){
  //             allMenus[index].classList.add("menuActiveColor");
  //           }
  //         })
  //       }else{
  //         allMenus[0].classList.add("menuActiveColor");
  //       }
  //   }
  //   this.state = {id : "1"};

  //   this.reload = false;
  // }
  //  Onclick on menu button
  classAdding(e, key,menu,menus) {
    let allMenus = document.querySelectorAll(".menuList");
    allMenus.forEach(function (eachMenu) {
      eachMenu.classList.remove("menuActiveColor");
    });
    allMenus[key].classList.add("menuActiveColor");
    sessionStorage.setItem("menuActiveColor", key);
  }
  componentDidMount() {
   this.acitiveColorHandle();
  }
  componentDidUpdate() {
   this.acitiveColorHandle();
  }

  anchor = null;
  handleClick = (event) => {
    event.stopPropagation();
    this.setState({
      open: !this.state.open,
      anchorEl: this.anchor,
    });
  };

  // in mini drawer mode, show icon and popup sub menus
  renderMiniMenus() {
    // eslint-disable-next-line react/prop-types
    const { menu, key, classes } = this.props;
    const { open, anchorEl } = this.state;

    // no sub menus
    if (!menu.subMenus || !menu.subMenus.length) {
      return (
        <Link style={{ textDecoration: "none" }} key={key} to={menu.link} onClick={(e) => this.classAdding(e, this.props.test,this.props.menus)} className={clsx("menuList",classes.activeColor)}>
          <MenuItem classes={{ root: classes.miniMenuItem }}>
            <Tooltip title={menu.text} placement="right" arrow>
              <ListItemIcon className={clsx(classes.miniIcon, "miniMenuIcon")}>
                {menu.icon}
              </ListItemIcon>
            </Tooltip>
          </MenuItem>
        </Link>
      );
    }

    return (
      <MenuItem
        key={key}
        classes={{ root: classes.miniMenuItem }}
        onClick={this.handleClick}
      >
        <Tooltip title={menu.text} placement="right" arrow>
          <ListItemIcon className={classes.miniIcon}>{menu.icon}</ListItemIcon>
        </Tooltip>
        <div
          ref={(el) => {
            this.anchor = el;
          }}
          style={{ position: "absolute", right: 0 }}
        />

        <Menu
          classes={{ paper: classes.popupSubMenus }}
          open={open}
          anchorEl={anchorEl}
          // onClose={() => alert("Closed")}
        >
          {menu.subMenus.map((subMenu, index) => (
            <Link
              style={{ textDecoration: "none" }}
              key={index}
              to={subMenu.link}
            >
              <MenuItem key={index} classes={{ root: classes.menuItem }}>
                {/* <ListItemIcon style={{ color: menuItemsColor }}>
                  {subMenu.icon}
                </ListItemIcon> */}
                <span>{subMenu.text}</span>
              </MenuItem>
            </Link>
          ))}
        </Menu>
      </MenuItem>
    );
  }

  renderLargeMenus() {
    // eslint-disable-next-line react/prop-types
    const { menu, key, classes } = this.props;
    const { open } = this.state;

    // no sub menus
    if (!menu.subMenus || !menu.subMenus.length) {
      return (
        <Link style={{ textDecoration: "none" }} key={key} to={menu.link} onClick={(e) => this.classAdding(e, this.props.test)} className={clsx("menuList",classes.activeColor)}>
          <MenuItem classes={{ root: classes.menuItem }}>
            <ListItemIcon style={{ color: menuItemsColor }}>
              {menu.icon}
            </ListItemIcon>
            <span>{menu.text}</span>
          </MenuItem>
        </Link>
      );
    }

    return (
      <div>
        <ListItem
          key={key}
          classes={{ root: classes.menuItem }}
          onClick={this.handleClick}
        >
          <ListItemIcon style={{ color: menuItemsColor }}>
            {menu.icon}
          </ListItemIcon>
          <span>{menu.text}</span>
          {open ? (
            <ExpandMore className={classes.chevronIcon} />
          ) : (
            <KeyboardArrowRight className={classes.chevronIcon} />
          )}
        </ListItem>

        {/* only open when the menu is open and Nav Drawer is open */}
        <Collapse in={this.state.open} timeout="auto" unmountOnExit>
          <List
            component="div"
            disablePadding
            classes={{ root: classes.subMenus }}
          >
            {menu.subMenus.map((subMenu, index) => (
              <Link
                style={{ textDecoration: "none" }}
                key={index}
                to={subMenu.link}
              >
                <MenuItem key={index} classes={{ root: classes.menuItem }}>
                  <ListItemIcon style={{ color: menuItemsColor }}>
                    {subMenu.icon}
                  </ListItemIcon>
                  <span>{subMenu.text}</span>
                </MenuItem>
              </Link>
            ))}
          </List>
        </Collapse>
      </div>
    );
  }

  render() {
    const { navDrawerOpen } = this.props;
    if (navDrawerOpen) {
      return this.renderLargeMenus();
    } else {
      return this.renderMiniMenus();
    }
  }
}

NestedMenuItem.propTypes = {
  key: PropTypes.string,
  menu: PropTypes.object,
  classes: PropTypes.object,
};

const StyledNestMenuItem = withStyles(styles, { withTheme: true })(
  NestedMenuItem
);
const Menus = (props) =>
  props.menus.map((menu, index, menus) => (
    <StyledNestMenuItem
      key={index}
      menu={menu}
      navDrawerOpen={props.navDrawerOpen}
      menuLength={menus.length}
      test={index}
      menus={menus}
    />
  ));
Menus.propTypes = {
  menus: PropTypes.array,
  navDrawerOpen: PropTypes.bool,
};
export default Menus;
